module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10076.26d0b9f0.jpg";